import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  logoutUser,
  fetchMeLogic,
  setSelectedClinic,
  getStaffLogic,
  setProvider,
} from "../../../store/features/app/appSlice";
import {
  getChatEnabledPatientsLogic,
  getChatHistoryLogic,
  getUnreadMessagesLogic,
  getUnreadPatientsChatLogic,
  updateUnreadMessageCount,
} from "../../../store/features/chat/chatSlice";
import { isEmptyObject } from "jquery";
import {
  alterSinglePatient,
  invitedPatientLogic,
  patientLogic,
} from "../../../store/features/patient/patientSlice";
import "./SidebarLayout.css";
import AgoraClientComponent from "../../pages/chat/AgoraMethods";
import DualLoginModal from "../../pages/chat/DualLoginModal";
import OPSMenu from "./OPSMenu";
import ClinicianMenu from "./ClinicianMenu";
import CaregiverMenu from "./CaregiverMenu";
import BillingMenu from "./BillingMenu";
import ClinicDD from "./ClinicDD";
import { SidebarLogo, ClinicPin } from "./SmallSidebarComponents";
import MenuItem from "./MenuItems";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";
import { ReactComponent as HomeIcon } from "../../../assets/icons/HomeIcon.svg";
import ACOMenu from "../../pages/aco/ACOMenu";
import AnonymousMenu from "./AnonymousMenu";
import { ROLES_LIST } from "../../../constants/constants";

const SidebarLayout = (props) => {
  const path = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, selectedClinic, selectedProvider } = useSelector(
    (state) => state.app
  );
  const { unreadMessagesCount } = useSelector((state) => state.chat);
  const [messageCount, setMessageCount] = useState(0);
  const [clinics, setClinics] = useState([]);
  const [didClinicChange, setDidClinicChange] = useState(false);

  useEffect(() => {
    const temp = user?.clinic_pin?.map((clinic) => {
      return {
        label: clinic.clinic.name,
        value: clinic,
      };
    });
    setClinics(temp);
    dispatch(fetchMeLogic(localStorage.getItem("access")));
  }, []);
  useEffect(() => {
    if (user) {
      if (user?.role === "CAREGIVER") {
        navigate("/caregiver/assessments");
      } else if (user?.role === "INVOCING_ADMIN") {
        navigate("/billing/");
      } else if (user?.role === "SALES_MANAGER") {
        if (!window.location.pathname.includes("ops")) {
          navigate("/ops/home");
        }
      } else if (user?.role === "ACO_EXECUTIVE") {
        if (!window.location.pathname.includes("aco")) {
          navigate("/aco/home/");
        }
      }
    }
  }, [user]);

  useEffect(() => {
    //console.log("unreadMessagesCount",unreadMessagesCount)
    if (Object.entries(unreadMessagesCount).length > 0) {
      if (selectedClinic && selectedClinic?.pin) {
        let count = unreadMessagesCount[selectedClinic?.pin];
        if (count > 0) {
          setMessageCount(unreadMessagesCount[selectedClinic?.pin]);
        } else {
          setMessageCount(null);
        }
      }
    }
  }, [unreadMessagesCount]);

  const handleLogout = () => {
    dispatch(logoutUser());
  };
  const setClinic = (clinic) => {
    console.log("Setting clinic",clinic);
    console.log("clinic.value.clinic_admin",clinic?.clinic_admin);
    dispatch(setSelectedClinic(clinic));
    dispatch(setProvider(clinic?.clinic_admin));
    setDidClinicChange(true);
  };


  const [remoteShow, setRemoteShow] = useState(false);

  const handleUnreadMessageBadge = (message, peerID) => {
    if (window.location.pathname !== "chat") {
      if (user && user?.pin) {
        dispatch(
          updateUnreadMessageCount({ count: messageCount + 1, pin: user?.pin })
        );
      }
    }
  };

  const resetEverything = () => {
    //! CAUTION: This function is intended to be called only when clinic is switched while browsing with a selected clinic.
    //! This will reset all redux store states and fetch relevant data based on the new clinic!
    if (!didClinicChange) {
      return;
    }
    try {
      if (isEmptyObject(selectedClinic) || !user) {
        return;
      }

      let userId = user?.id;
      if (selectedProvider) {
        userId = selectedProvider;
      }
      dispatch(
        patientLogic({
          page_size: 999999,
          page: 1,
          clinic_id: selectedClinic?.clinic?.id,
          clinician_id: userId,
        })
      );
      dispatch(
        invitedPatientLogic({
          page_size: 999999,
          page: 1,
          status: "INVITED",
          clinic_id: selectedClinic?.clinic?.id,
          clinician_id: userId,
        })
      );
      dispatch(
        getChatHistoryLogic({
          page_size: "9999999",
          clinic_id: selectedClinic?.clinic?.id,
          clinician_id: userId,
        })
      );
      dispatch(
        getChatEnabledPatientsLogic({
          clinic_id: selectedClinic?.clinic?.id,
          clinician_id: userId,
        })
      );
      dispatch(getStaffLogic());
      //* Patient API Calls
      dispatch(alterSinglePatient({}));
    } catch (e) {
      console.log("Something went wrong while resetting everything", e);
    } finally {
      setDidClinicChange(false);
    }
  };

  useEffect(() => {
    resetEverything();
  }, [didClinicChange]);

  useEffect(() => {
    if (!user) {
      navigate("/login/");
    }
  }, [user]);

  useEffect(() => {
    if (!selectedClinic) {
      if (!user) {
        navigate("/login/");
      } else if (user.role === "INVOICING_ADMIN") {
        if (!window.location.pathname.includes("billing")) {
          if (!window.location.pathname.includes("settings")) {
            navigate("/billing/");
          }
        }
      } else if (user.role === "CAREGIVER") {
        navigate("/caregiver/assessments");
      } else if (user.role === "SALES_MANAGER") {
        if (!window.location.pathname.includes("ops")) {
          navigate("/ops/home");
        }
      } else if (
        user?.role === "CLINIC_ADMIN" ||
        user?.role === "CLINICAL_STAFF"
      ) {
        navigate("/dashboard/select-clinic");
      } else if (user?.role === "ACO_EXECUTIVE") {
        if (
          !window.location.pathname.includes("aco") ||
          window.location.pathname === "/aco"
        ) {
          navigate("/aco/home");
        }
      }
    }
    if (
      !isEmptyObject(selectedClinic) &&
      user &&
      (path.includes("select-clinic") || path === "/dashboard/")
    ) {
      if (user?.role === "CLINIC_ADMIN" || user?.role === "CLINICAL_STAFF") {
        navigate("/dashboard/home/");
        dispatch(getUnreadMessagesLogic());
        dispatch(getUnreadPatientsChatLogic(selectedClinic?.clinic?.id));
      }
    }
  }, [selectedClinic]);

  return (
    <section
      id="dashboard"
      className="container-fluid row"
      style={{ margin: "0px", padding: "0px" }}
    >
      <div id="sidebar" className="sidebar col-sm-12 col-md-2 col-lg-2">
        <SidebarLogo />
        <hr style={{ color: "white", width: "100%" }} />
        {user?.role === "CLINIC_ADMIN" && (
          <>
            <ClinicDD
              clinics={clinics}
              clinicName={selectedClinic?.clinic?.name || "Select Clinic"}
              setClinic={setClinic}
            />
            {selectedClinic && (
              <ClinicPin pin={selectedClinic?.pin || "0000"} />
            )}
            <ClinicianMenu
              path={path}
              messageCount={messageCount}
              handleLogout={handleLogout}
            />
            <AgoraClientComponent
              callback={handleUnreadMessageBadge}
              setRemoteShow={setRemoteShow}
            />
          </>
        )}
        {user?.role === "CLINICAL_STAFF" && (
          <>
            <ClinicDD
              clinics={clinics}
              clinicName={selectedClinic?.clinic?.name || "Select Clinic"}
              setClinic={setClinic}
            />
            {selectedClinic && (
              <ClinicPin pin={selectedClinic?.pin || "0000"} />
            )}
            <ClinicianMenu
              path={path}
              messageCount={messageCount}
              handleLogout={handleLogout}
            />
            <AgoraClientComponent
              callback={handleUnreadMessageBadge}
              setRemoteShow={setRemoteShow}
            />
          </>
        )}
        {user?.role === "CAREGIVER" && (
          <CaregiverMenu handleLogout={handleLogout} />
        )}
        {user?.role === "ACO_EXECUTIVE" && (
          <ACOMenu path={path} handleLogout={handleLogout} />
        )}
        {user?.role === "INVOICING_ADMIN" && (
          <BillingMenu path={path} handleLogout={handleLogout} />
        )}
        {user?.role === "SALES_MANAGER" && (
          <OPSMenu path={path} handleLogout={handleLogout} />
        )}
        {ROLES_LIST.includes(user?.role) === false && (
          <AnonymousMenu handleLogout={handleLogout} />
        )}
      </div>

      {/* {remoteShow && (
        <DualLoginModal modalIsOpen={remoteShow} setIsOpen={setRemoteShow} />
      )} */}
      <div
        id="main"
        style={{
          margin: "0px",
          padding: "0px",
          background: !path.includes("selected-clinic") && "#f1f5f9",
        }}
        className="col-sm-12 col-md-10 col-lg-10"
      >
        <div
          style={{ margin: "0px", padding: "0px" }}
          className="container-fluid"
        >
          {props.children}
        </div>
      </div>
    </section>
  );
};

export default SidebarLayout;
